import React from "react";

function Gjaldskra() {
	const openInNewTab = (url) => {
		const newWindow = window.open(url, "_blank", "noopener,noreferrer");
		if (newWindow) newWindow.opener = null;
	};

	return (
		<div className="gjaldskraBody">
			<div className="TitleWButton">
				<h1>Gjaldskrá og greiðslukerfi SÍ</h1>
			</div>

			<div className="GjaldskraFlex">
				<div className="GjaldskraTextSection">
					<p>
						Einstaklingar geta skoðað greiðsluþátttöku sína í{" "}
						<span
							className="Linkur"
							onClick={() =>
								openInNewTab("https://rg.sjukra.is/Account/Login.aspx")
							}
							style={{
								textDecoration: "underline",
								fontWeight: "bold",
								cursor: "pointer",
							}}
						>
							Gagnagátt
						</span>
						.
					</p>
					<p>
						<p>
							Sjá nánar:{" "}
							<span
								className="Linkur"
								onClick={() =>
									openInNewTab(
										"https://island.is/s/sjukratryggingar/fagadilar-sjukrathjalfun"
									)
								}
								style={{
									textDecoration: "underline",
									fontWeight: "bold",
									cursor: "pointer",
								}}
							>
								www.sjukra.is
							</span>
						</p>
					</p>

					<h3 style={{ marginTop: "2rem", marginBottom: "1rem" }}>
						Niðurgreiðsla fyrir fullorðna (18 ára og eldri)
					</h3>
					<p style={{ marginBottom: "1.5rem" }}>
						Frá 1. febrúar 2023 er hægt að koma til sjúkraþjálfara í 6 skipti án
						beiðni. Ef þarf að koma oftar en 6 skipti þarf að liggja fyrir
						beiðni frá lækni til að fá niðurgreitt frá Sjúkratryggingum Íslands.
					</p>

					<h3 style={{ marginTop: "2rem", marginBottom: "1rem" }}>
						Niðurgreiðsla fyrir börn (yngri en 18 ára)
					</h3>
					<p style={{ marginBottom: "1.5rem" }}>
						Börn yngri en 18 ára þurfa beiðni frá lækni í fyrsta tíma. Með
						beiðni er þjálfunin gjaldfrjáls. Án beiðni greiða börn 30% af gjaldi
						fyrstu 6 tímana.
					</p>

					<h3 style={{ marginTop: "2rem", marginBottom: "1rem" }}>
						Afbókunarreglur
					</h3>
					<p style={{ marginBottom: "1.5rem" }}>
						Afboða þarf bókaðan tíma hjá sjúkraþjálfara með góðum fyrirvara ef
						fólk hefur ekki tök á að mæta. Ef afboð berst innan 2 klukkustunda
						fyrir bókaðan tíma þarf að greiða 7.000 króna gjald.
					</p>
					<p style={{ marginBottom: "1.5rem", fontStyle: "italic" }}>
						Vinsamlegast athugið að tímabókanir eru á ábyrgð viðskiptavina og
						Sjúkratryggingar Íslands taka ekki þátt í tímum sem ekki er mætt í.
					</p>
					<p style={{ marginBottom: "1.5rem", fontStyle: "italic" }}>
						Sjúkratryggingar Íslands niðurgreiða einungis 1 tíma á dag í
						sjúkraþjálfun.
					</p>
				</div>
			</div>
		</div>
	);
}

export default Gjaldskra;
